import { createContext, useContext, useState, useMemo } from 'react';

const AppStateContext = createContext();

export const AppStateProvider = ({ children }) => {
	const [pageState, setPageState] = useState({});

	const setPageData = (page, data) => {
		setPageState((prev) => ({
			...prev,
			[page]: data,
		}));
	};

	const getPageData = (page) => pageState[page] || {};

	const clearPageData = (page) => {
		setPageState((prev) => {
			const newState = { ...prev };
			delete newState[page];
			return newState;
		});
	};

	const value = useMemo(
		() => ({ setPageData, getPageData, clearPageData }),
		[pageState] // depends only if needed
	);

	return <AppStateContext.Provider value={value}>{children}</AppStateContext.Provider>;
};

export const useAppState = () => useContext(AppStateContext);
